<template>

    <div class="container">

        <back :href="route('admin.suppliers.index')" />

        <div class="d-flex justify-content-start align-items-center mb-3 gap-3">
            <h1 class="">{{ __('Customer Relations') }} / {{ supplier.name }}</h1>
            <div class="">
                <inertia-link class="btn btn-primary" :href="route('admin.suppliers.customer-relations.create', supplier)">
                    {{ __('Create') }}
                </inertia-link>
            </div>
        </div>

        <div class="d-flex mb-3">
            <search-filter v-model="form.search" class="" @reset="reset">
            </search-filter>
        </div>

        <results :meta="supplierCustomerRelations.meta" />

        <div class="card">
            <data-table :items="supplierCustomerRelations.data"
                        :links="supplierCustomerRelations.meta.links"
                        :columns="columns"
                        >
                <data-table-row v-for="supplierCustomerRelation in supplierCustomerRelations.data" :key="supplierCustomerRelation.pivot.id">
                    <td>
                        {{ supplierCustomerRelation.customer_number || '-' }}
                    </td>
                    <td>
                        {{ supplierCustomerRelation.name }}
                    </td>
                    <td>
                        {{ supplierCustomerRelation.pivot.internal_customer_number || '-'  }}
                    </td>
                    <td>
                        {{ supplierCustomerRelation.pivot.notes || '-'  }}
                    </td>
                    <td class="text-end py-0">
                        <div class="dropdown">
                            <button class="btn btn-outline-secondary" 
                                    type="button" 
                                    :id="`dropdownMenuCustomer-${supplierCustomerRelation.pivot.id}`" 
                                    :title="__('Edit')"
                                    data-bs-toggle="dropdown" 
                                    aria-expanded="false">
                                <i class="bi bi-three-dots-vertical"></i>
                                {{ __('Edit') }}
                            </button>
                            <div class="dropdown-menu dropdown-menu-end" :aria-labelledby="`dropdownMenuCustomer-${supplierCustomerRelation.pivot.id}`">
                                <inertia-link :href="route('admin.customer-relations.edit', supplierCustomerRelation.pivot.id)" class="dropdown-item">
                                    {{ __('Bearbeiten') }}
                                </inertia-link>
                                <inertia-link :href="route('admin.customer-relations.destroy', supplierCustomerRelation.pivot.id)" method="delete" as="button" class="dropdown-item">
                                    {{ __('Delete') }}
                                </inertia-link>
                            </div>
                        </div>
                    </td>
                </data-table-row>
            </data-table>
        </div>

    </div>

</template>

<script>
    import DataTable from '@/shared/Admin/DataTable';
    import DataTableRow from '@/shared/Admin/DataTableRow';

    import SearchFilter from '@/shared/Admin/SearchFilter';
    import SelectInput from '@/shared/Inputs/SelectInput';

    import Results from '@/shared/Admin/Results';

    import TextInput from '@/shared/Inputs/TextInput';
    import TextareaInput from '@/shared/Inputs/TextareaInput';
    import CheckboxInput from '@/shared/Inputs/CheckboxInput';
    import SwitchInput from '@/shared/Inputs/SwitchInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';

    export default {
        props: [
            'supplier',
//            'customers',
            'filters',
            'supplierCustomerRelations',
        ],
        components: {
            SearchFilter,
            SelectInput,
            DataTable,
            DataTableRow,
            Results,
            TextInput,
            TextareaInput,
            CheckboxInput,
            SwitchInput,
            SubmitButton,
        },
        data() {
            return {
                form: this.$inertia.form({
                    search: this.filters.search,
                }),
                columns: {
                    customer_number: {label: 'Customer Number', sortable: 'customer_number'},
                    name: {label: 'Name', sortable: 'name'},
                    internal_customer_number: {label: 'Internal customer number'},
                    notes: {label: 'Notes'},
                },
            }
        },
        watch: {
            form: {
                deep: true,
                handler: _.debounce(function () {
                    this.$inertia.get(this.route('admin.suppliers.customer-relations.index', this.supplier), this.form, {preserveState: true})
                }, 300, {trailing: true}),
            },
        },
        methods: {
            reset() {
                this.form = _.mapValues(this.form, () => null)
            },
        },
    }
</script>